import PatientService from 'Services/PatientService'
import IssueService from 'Services/IssueService'

const initialState = {
    patient: {
        id: null,
        physiotherapist_id: null,
        first_name: '',
        last_name: '',
        pesel: '',
        born_date: '',
        gender: null,
        address_street: '',
        address_postcode: '',
        address_city: '',
        email: '',
        phone: '',
        contact_person_first_name: '',
        contact_person_last_name: '',
        contact_person_address_street: '',
        contact_person_address_postcode: '',
        contact_person_address_city: '',
        contact_person_email: '',
        contact_person_phone: ''
    },
    patients: {},
    patientsList: [],
    patientIssues: []
}

export default {

    state: Object.assign({}, JSON.parse(JSON.stringify(initialState))),

    getters: {
        patients: state => state.patients,
        patientsList: state => state.patientsList,
        patient: state => state.patient,
        patientIssues: state => state.patientIssues
    },

    mutations: {
        SET_PATIENTS(state, patients) {
            state.patients = patients
        },
        SET_PATIENTS_LIST(state, patientsList) {
            var _patients = []
            const len = patientsList ? patientsList.length : 0
            for (let i = 0; i < len; i++) {
                let p = patientsList[i]
                _patients.push({
                    id: p.id,
                    name: p.first_name + ' ' + p.last_name,
                })
            }
            state.patientsList = _patients
        },
        SET_PATIENT(state, patient) {
            state.patient = patient
        },
        REMOVE_PATIENT(state, patientId) {
            state.patients.data = state.patients.data.filter((patient) => {
                return patient.id !== patientId
            })
        },
        SET_ISSUES(state, issues) {
            state.patientIssues = issues
        }
    },

    actions: {
        PATIENTS_FETCH(context, query = {}) {
            query.paginate = 1

            return PatientService.list(query).then(({data}) => {
                context.commit('SET_PATIENTS', data.data)
            })
        },
        PATIENTS_LIST_FETCH(context) {
            const query = {fields: 'id,first_name,last_name'}
            return PatientService.list(query).then(({data}) => {
                context.commit('SET_PATIENTS_LIST', data.data)
            })
        },
        PATIENT_FETCH(context, patientId) {
            return PatientService.get(patientId).then((response) => {
                context.commit('SET_PATIENT', response.data.data)
                return response
            })
        },
        PATIENT_STORE({state}) {
            return PatientService.store(state.patient)
        },
        PATIENT_UPDATE({state}) {
            return PatientService.update(state.patient)
        },
        PATIENT_DELETE(context, patientId) {
            return PatientService.delete(patientId).then((result) => {
                context.commit('REMOVE_PATIENT', patientId)
                return result
            })
        },
        PATIENT_ISSUES_FETCH(context, patientId) {
            const query = {
                patient_id: patientId,
                paginate: 0
            }
            return IssueService.list(query).then((result) => {
                context.commit('SET_ISSUES', result.data.data)
                return result
            })
        },
        PATIENT_RESET(context) {
            context.commit('SET_PATIENT', JSON.parse(JSON.stringify(initialState.patient)))
        }
    }

}